<template>
  <div class="spinner-wheel_result">
    <canvas
      id="firework-canvas"
    />
    <p>{{ $t('resultsAreIn') }}</p>
    <div class="spinner-wheel_result-picked" v-if="slide.metadata.winner" :style="winnerStyle">
      <span v-if="slide.metadata.winner.entryType === 'manual_presenter'">
        {{ slide.metadata.winner.winnerLabel }}
      </span>
      <span v-else>
        {{ slide.metadata.winner.winnerLabel | profanity }}
      </span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Constant from '@/constant'
import utils from '@/util'

export default {
  components: {
  },
  computed: {
    ...mapGetters({
      slide: 'activeActivity',
    }),

    winnerStyle() {
      if (!this.slide.metadata) {
        return {}
      }
      return {
        backgroundColor: this.slide.metadata.winner.color,
      }
    },
  },
  mounted() {
    this.getFireWork()
  },
  methods: {
    getFireWork() {
      // Firing confetti effect only available if the canvas element is mounted to the DOM
      const canvas = document.getElementById('firework-canvas')
      if (!canvas) return
      const colors = Constant.colorsHex.filter((item, key) => {
        return item && key < 7
      })

      this.startConfettiEffect = utils.setupConfettiEffect(canvas, { resize: true },
        {
          startVelocity: 5,
          spread: 360,
          ticks: 100,
          decay: 0.98,
          particleCount: 40,
          shapes: ['circle'],
          colors,
          zIndex: 100,
        })

      const self = this
      if (!this.startConfettiEffect) {
        return
      }

      let start = null

      // eslint-disable-next-line
      function step(timestamp) {
        if (!start) start = timestamp
        const progress = timestamp - start
        if (progress > 800) {
          start = null
          self.startConfettiEffect({
            x: Math.random(),
            y: Math.random() - 0.3,
          })
        }
        self.myReqAnimationFrame = window.requestAnimationFrame(step)
      }
      self.myReqAnimationFrame = window.requestAnimationFrame(step)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.spinner-wheel_result {
  margin: 120px 0;

  p {
    font-size: 16px;
    margin-bottom: 20px;
    font-weight: bold;
  }
}
.spinner-wheel_result-picked {
  border-radius: 8px;
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  padding: 16px;
}

#firework-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>
